<template>
	<LayoutOffcanvasStandard ref="offcanvas" title="Seleccionar balance" id="home-balance-modal-select">
		<template #body>
			<div class="list-group list-group-flush gap-5">
				<template v-if="balances.length > 0">
					<div class="list-group-item hstack gap-5 border-0 p-0" v-for="balance in balances" :key="balance.id">
						<div>
							<router-link :to="{ name: 'balance.show', params: { id: balance.id }}" class="d-block h5 fw-bold stretched-link">{{ balance.company.name }}</router-link>
							<p class="text-sm lh-xs">{{ vueNumberFormat(balance.amount, { suffix: ` ${balance.currency}`, precision: 2 }) }}</p>
						</div>
						<div class="ms-auto text-end align-self-center">
							<i class="bi bi-chevron-right"></i>
						</div>
					</div>
				</template>
				<template v-else>
					<li class="list-group-item hstack gap-5 border-0 p-0">
						No se encontraron balances activos.
					</li>
				</template>
			</div>
		</template>
	</LayoutOffcanvasStandard>
</template>

<script>
	import { ref } from 'vue';

	export default {
		props: {
			balances: {
				type: Array,
				default: []
			}
		},
		setup(props, { emit }) {
			const offcanvas = ref(null);
			const show = () => offcanvas.value.offcanvas.show();

			return { offcanvas, show };
		}
	}
</script>